// import { useState } from 'react';
// import MenuItem from '@mui/material/MenuItem';
// import FormControl from '@mui/material/FormControl';
// import ListItemText from '@mui/material/ListItemText';
// import Select from '@mui/material/Select';
// import { NativeSelect } from '@mui/material';
// import React from 'react';

// const ITEM_HEIGHT = 60;
// const ITEM_PADDING_TOP = 10;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250
//     }
//   }
// };

// const names = ['Detections', 'Engagement', 'Journey', 'Customer-Product Engagement', 'Zonal Conversion', 'Interaction', 'Queue Count', 'Staff Avability', 'Light Timing'];

// export default function MultipleSelectCheckmarks({ graphToSelect }) {
//   const [personName, setPersonName] = useState('Detections');
//   const [open, setOpen] = useState(false);

//   const handleChange = (event) => {
//     const {
//       target: { value }
//     } = event;
//     setPersonName(value);
//     graphToSelect(value);
//     setOpen(false);
//   };
//   // const handelClickbtn = ()=>{
//   //   graphToSelect(personName);
//   //   setOpen(false);
//   // }

//   return (
//     <div>
//       <FormControl sx={{ m: 1, width: 200 }}>
//         <Select
//           labelId="demo-multiple-checkbox-label"
//           id="demo-multiple-checkbox"
//           value={personName}
//           onChange={handleChange}
//           input={<NativeSelect />}
//           renderValue={(selected) => selected}
//           MenuProps={MenuProps}
//           open={open}
//           onOpen={() => setOpen(true)}
//           onClose={() => setOpen(false)}
//         >
//           {names.map((name) => (
//             <MenuItem
//               key={name}
//               value={name}
//               disabled={name === 'Engagement'}
//               sx={{
//                 '&.Mui-disabled': {
//                   opacity: 0.6,
//                   cursor: 'not-allowed'
//                 }
//               }}
//             >
//               <ListItemText primary={name} />
//             </MenuItem>
//           ))}
//           {/* <Box sx={{width:"100%", display:"flex", justifyContent:"flex-end", overflow:"hidden"}}>
//            <Button sx={{margin:"10px"}} onClick={ handelClickbtn} variant="contained">Done</Button>
//            </Box> */}
//         </Select>
//       </FormControl>
//     </div>
//   );
// }

import { useState } from 'react';
import { Chip, Box } from '@mui/material';

const names = [
  'FootFall',
  'Journey',
  'Customer-Product Engagement',
  'Zonal Conversion',
  'Interaction',
  'Queue Count',
  'Staff Availability',
  'Light Timing'
];

export default function SelectableChips({ graphToSelect }) {
  const [selected, setSelected] = useState('FootFall');

  const handleSelect = (name) => {
    if (name === 'Engagement') return; // Disable selection for 'Engagement'
    setSelected(name);
    graphToSelect(name);
  };

  return (
    <Box
      className="scrollbar"
      sx={{
        display: 'flex',
        gap: 1,
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        p: 1,
        width: '100%'
      }}
    >
      {names.map((name) => (
        <Chip
          key={name}
          label={name}
          onClick={() => handleSelect(name)}
          sx={{
            borderRadius: '20px',
            px: 1.5,
            marginTop: '2px',
            backgroundColor: selected === name ? '#44BE54' : '#f0f0f0',
            color: selected === name ? '#fff' : '#000',
            opacity: name === 'Engagement' ? 0.6 : 1,
            transition: 'background-color 0.2s ease-in-out',
            '&:hover': {
              backgroundColor: selected === name ? '#329242' : '#e0e0e0'
            }
          }}
        />
      ))}
    </Box>
  );
}
